<template>
  <div class="electricity">
    <h3>Gas</h3>
  </div>
</template>

<script>
export default {
  name: 'Gas',
}
</script>
